module.exports = __webpack_public_path__ + "img/gray-shield.dafbd0d6.svg";